var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimeDocs({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 300,
    height: 20,
    viewBox: "0 0 300 20",
    id: "",
    className: "style-svg replaced-svg svg-replaced-8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Prime_Doc"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prime_Doc",
    "data-name": "Prime Doc",
    clipPath: "url(#clip-Prime_Doc)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 20
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M128,.484h6.532a12.9,12.9,0,0,1,3.656.538A9.815,9.815,0,0,1,141.5,2.715a8.669,8.669,0,0,1,2.392,2.957A9.472,9.472,0,0,1,144.8,10a9.279,9.279,0,0,1-.914,4.247A9.024,9.024,0,0,1,141.5,17.2a10.643,10.643,0,0,1-3.307,1.747,12.326,12.326,0,0,1-3.656.565H128Zm2.661,16.694H134a9.978,9.978,0,0,0,3.172-.484,7.206,7.206,0,0,0,2.527-1.4,6.193,6.193,0,0,0,1.666-2.258A7.473,7.473,0,0,0,141.953,10a7.686,7.686,0,0,0-.592-3.118A5.952,5.952,0,0,0,139.7,4.651a6.887,6.887,0,0,0-2.527-1.371A9.978,9.978,0,0,0,134,2.8h-3.334Z",
    fill: "#95c147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M167.645,9.973a10.367,10.367,0,0,1-.78,4.059,9.609,9.609,0,0,1-2.1,3.172,9.748,9.748,0,0,1-3.2,2.07,11.562,11.562,0,0,1-8.064,0,9.817,9.817,0,0,1-3.172-2.07,9.609,9.609,0,0,1-2.1-3.172,10.692,10.692,0,0,1-.753-4.059,10.562,10.562,0,0,1,.753-4.059,8.974,8.974,0,0,1,2.1-3.145A9.465,9.465,0,0,1,153.505.726a11.562,11.562,0,0,1,8.064,0,9.4,9.4,0,0,1,3.2,2.043,8.974,8.974,0,0,1,2.1,3.145A10.241,10.241,0,0,1,167.645,9.973Zm-2.877,0a8.314,8.314,0,0,0-.511-2.93A7.441,7.441,0,0,0,162.806,4.6a6.6,6.6,0,0,0-2.285-1.64,6.941,6.941,0,0,0-2.984-.618,7.057,7.057,0,0,0-2.984.618,6.662,6.662,0,0,0-2.258,1.64,7.722,7.722,0,0,0-1.425,2.446,8.336,8.336,0,0,0-.51,2.93,8.638,8.638,0,0,0,.51,2.984,7.46,7.46,0,0,0,1.452,2.446,6.838,6.838,0,0,0,2.258,1.613,7.142,7.142,0,0,0,2.957.591,7.331,7.331,0,0,0,2.984-.591,6.767,6.767,0,0,0,2.285-1.613,7.44,7.44,0,0,0,1.451-2.446A8.615,8.615,0,0,0,164.768,9.973Z",
    fill: "#95c147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M187.581,16.559a8.673,8.673,0,0,1-2.93,2.5,9.243,9.243,0,0,1-4.328.941,10.964,10.964,0,0,1-4.032-.726,9.817,9.817,0,0,1-3.172-2.07,9.8,9.8,0,0,1-2.07-3.172,10.692,10.692,0,0,1-.753-4.059,10.562,10.562,0,0,1,.753-4.059,9.271,9.271,0,0,1,2.123-3.145A9.711,9.711,0,0,1,176.4.726,10.973,10.973,0,0,1,180.43,0a10.539,10.539,0,0,1,1.963.188A9.756,9.756,0,0,1,184.3.753a7.553,7.553,0,0,1,1.667.941,5.744,5.744,0,0,1,1.29,1.263l-2.1,1.613a5.108,5.108,0,0,0-1.99-1.586,5.94,5.94,0,0,0-2.742-.645,7.118,7.118,0,0,0-3.01.618,6.662,6.662,0,0,0-2.258,1.64,7.426,7.426,0,0,0-1.452,2.446,8.314,8.314,0,0,0-.511,2.93,9.158,9.158,0,0,0,.484,3.011,7.721,7.721,0,0,0,1.425,2.446,6.839,6.839,0,0,0,2.258,1.613,7.331,7.331,0,0,0,2.984.591,6.57,6.57,0,0,0,2.93-.645,5.638,5.638,0,0,0,2.177-1.882Z",
    fill: "#95c147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M197.554,20a8.051,8.051,0,0,1-3.279-.618,6.787,6.787,0,0,1-2.312-1.694,7.074,7.074,0,0,1-1.371-2.392,9.366,9.366,0,0,1-.43-2.823V.484h2.661V12.312a7.968,7.968,0,0,0,.242,1.936,5.03,5.03,0,0,0,.78,1.694,4.168,4.168,0,0,0,1.451,1.21,5.02,5.02,0,0,0,2.258.457,4.949,4.949,0,0,0,2.231-.457,3.863,3.863,0,0,0,1.452-1.21,4.792,4.792,0,0,0,.807-1.694,7.967,7.967,0,0,0,.241-1.936V.484h2.662V12.473a8.886,8.886,0,0,1-.457,2.823,6.724,6.724,0,0,1-1.344,2.392,6.8,6.8,0,0,1-2.312,1.694A8.052,8.052,0,0,1,197.554,20Z",
    fill: "#95c147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M219.272,15.108h.054L224.944.484h4.14V19.516h-2.661V3.6h-.054l-6.317,15.914h-1.694L212.068,3.6h-.054V19.516h-2.58V.484h4.139Z",
    fill: "#95c147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M236.378,17.15h9.946v2.366H233.716V.484h12.205V2.823h-9.543v5.7h8.978v2.285h-8.978Z",
    fill: "#95c147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M263.275,15.7h.054V.484h2.661V19.516h-3.36L252.576,3.978h-.053V19.516h-2.662V.484h3.468Z",
    fill: "#95c147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M277.293,19.516h-2.661V2.823h-6.1V.484h14.865V2.823h-6.1Z",
    fill: "#95c147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M295.393,4.005a4.123,4.123,0,0,0-1.532-1.263,4.592,4.592,0,0,0-2.177-.511,4.871,4.871,0,0,0-1.317.188,3.269,3.269,0,0,0-1.183.565,3.063,3.063,0,0,0-.887.968,2.723,2.723,0,0,0-.323,1.371,2.7,2.7,0,0,0,.3,1.317,3.266,3.266,0,0,0,.833.887,6.653,6.653,0,0,0,1.237.618l1.532.511q.967.3,1.962.672a7.018,7.018,0,0,1,1.8.995,4.857,4.857,0,0,1,1.318,1.559,4.764,4.764,0,0,1,.51,2.339A5.593,5.593,0,0,1,296.9,16.8a5.285,5.285,0,0,1-1.452,1.8,6.36,6.36,0,0,1-2.123,1.048,8.591,8.591,0,0,1-2.447.35,9.078,9.078,0,0,1-3.494-.7,6.931,6.931,0,0,1-2.769-2.07l2.07-1.747a5.062,5.062,0,0,0,1.8,1.613,5.057,5.057,0,0,0,3.79.43,3.634,3.634,0,0,0,1.21-.591,3.234,3.234,0,0,0,.914-.995,2.958,2.958,0,0,0,.349-1.478,2.516,2.516,0,0,0-.376-1.425,3.016,3.016,0,0,0-.968-.995,6.043,6.043,0,0,0-1.451-.672q-.807-.3-1.721-.591a16.672,16.672,0,0,1-1.8-.645,6.8,6.8,0,0,1-1.586-.995,4.753,4.753,0,0,1-1.129-1.505,5.03,5.03,0,0,1-.43-2.2,4.989,4.989,0,0,1,.564-2.446,5.5,5.5,0,0,1,1.506-1.694,6.224,6.224,0,0,1,2.1-.968A8.952,8.952,0,0,1,291.818,0a8.181,8.181,0,0,1,3.118.591,6.2,6.2,0,0,1,2.339,1.586Z",
    fill: "#95c147"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M19.032,0A.968.968,0,0,1,20,.968V8.71a.968.968,0,0,1-.968.968H11.29a.968.968,0,0,1-.968-.968V0ZM0,.968A.968.968,0,0,1,.968,0H8.71a.968.968,0,0,1,.968.968V8.71a.968.968,0,0,1-.968.968H0ZM20,19.032v-8.71H11.29a.968.968,0,0,0-.968.968v7.742A.968.968,0,0,0,11.29,20h7.742A.968.968,0,0,0,20,19.032ZM0,11.29a.968.968,0,0,1,.968-.968H8.71a.968.968,0,0,1,.968.968v7.742A.968.968,0,0,1,8.71,20H0ZM1.971,1.612a.359.359,0,0,0-.359.359V3.226H2.867a.359.359,0,0,0,.359-.359v-.9a.359.359,0,0,0-.359-.359Z",
    fill: "#95c147",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M31.393,19.777V13.52h8.269c4.3,0,5.244-2.765,5.244-6.676S43.963.223,39.662.223H29.34c-1.8,0-2.941.922-2.941,3.017V19.777Zm0-10.168V5.447c0-.978.333-1.313,1.3-1.313h4.384c2.081,0,2.719.754,2.719,2.709s-.638,2.765-2.719,2.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M47.264,19.777h4.995V5.447c0-.978.333-1.313,1.3-1.313H58.2c1.887,0,2.47.67,2.47,2.682,0,1.955-.416,2.905-2.275,2.905H56.754c-1.8,0-2.858.335-2.858,1.76v.447c0,1.089,1.027,1.955,1.748,2.765l4.384,5.084H66.16L59.972,13.52v-.14H61.36c3.579,0,4.412-3.324,4.412-6.732,0-4.05-1.165-6.425-5.189-6.425H50.205c-1.8,0-2.941.922-2.941,3.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M73.5,19.777V.223H68.509V19.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M96.591,6.285c.139-.391.277-.67.416-.67.166,0,.305.223.305.615l-.167,13.547h5V3.017c0-1.508-.777-3.017-3.968-3.017a3.981,3.981,0,0,0-4.19,2.877L89.9,14.162c-.111.335-.333.81-.555.81s-.444-.475-.555-.81L84.715,2.877A3.994,3.994,0,0,0,80.5,0c-1.471,0-3.94.391-3.94,3.017v16.76h4.995L81.413,6.229c0-.14,0-.615.278-.615.166,0,.305.363.416.67l3.968,11.229C86.6,18.994,87.129,20,89.349,20c2.192,0,2.719-1.006,3.247-2.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M121.487.223H108.141c-1.8,0-2.942.922-2.942,3.017V16.788a2.642,2.642,0,0,0,2.942,2.989H121.6v-3.8H111.5c-.971,0-1.3-.335-1.3-1.313V11.676h11.044V8.045H110.194V5.335c0-.978.333-1.313,1.3-1.313h9.989Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimeDocs);
export default __webpack_public_path__ + "static/media/prime_docs.ebdfb23e2a70d5f4049ca1387f4763bb.svg";
export { ForwardRef as ReactComponent };